export enum AppRoutes {
  error = 'error',
  home = 'home',
  login = 'login',
  info = 'info',
  settings = 'settings',
  notAvailableReason = 'notAvailableReason',
  outbound = 'outbound',
  call = 'call',
  sessionInvitations = 'sessionInvitations',
}
